import $ from "jquery";

export const toggleInfoModal = () => {
    const infoModal = $(".toggle-info-modal");

    $(".toggle-info-modal-button").on('click', function (event) {
        infoModal.toggleClass('show');
    });

    $(document).mouseup(function (e) {
        if (!infoModal.is(e.target) && infoModal.has(e.target).length === 0) {
            infoModal.removeClass('show');
        }
    });
};
